import { initializeApp, FirebaseOptions } from 'firebase/app';
import { initializeFirestore } from 'firebase/firestore';
import { getAuth, setPersistence, browserLocalPersistence } from 'firebase/auth';
import { getStorage } from 'firebase/storage';
import { getFunctions } from 'firebase/functions';

// Firebase configuration for JLS Apps (used for both auth and data)
const firebaseConfig: FirebaseOptions = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY!,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN!,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID!,
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET!,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID!,
  appId: process.env.REACT_APP_FIREBASE_APP_ID!
};

// Initialize Firebase app
const app = initializeApp(firebaseConfig);

// Initialize Firestore with minimal settings
export const db = initializeFirestore(app, {
  cacheSizeBytes: 10 * 1024 * 1024, // 10MB cache size
  experimentalForceLongPolling: false // Use WebSocket by default
});

// Initialize Auth
export const auth = getAuth(app);

// Set up auth persistence with fallback to session persistence
const setupAuthPersistence = async () => {
  try {
    await setPersistence(auth, browserLocalPersistence);
  } catch (error: any) {
    // If storage access is not allowed, the auth state will default to session persistence
    // Silently handle persistence setup errors - auth will still work with session persistence
  }
};

setupAuthPersistence();

// Initialize Storage
export const storage = getStorage(app);

// Initialize Functions
export const functions = getFunctions(app);
export const functionsUsEast1 = getFunctions(app, 'us-east1');

// Connect to emulator in development
if (process.env.NODE_ENV === 'development') {
  const { connectFunctionsEmulator } = require('firebase/functions');
  connectFunctionsEmulator(functions, 'localhost', 5001);
  connectFunctionsEmulator(functionsUsEast1, 'localhost', 5001);
}

// Export the app for use in other parts of the application
export { app };

// For backward compatibility with existing code that might be using authApp or dataApp
export const authApp = app;
export const dataApp = app;
